// DOSMIL Lookbook runtime (robust init + crisp magnifier)
(function(){
  const ZOOM=2.2, LENS=160, THUMB_W=260, MAIN_MAX=1600, LENS_MAX=2800;
  const q=(s,r=document)=>r.querySelector(s), qa=(s,r=document)=>Array.from(r.querySelectorAll(s));
  const resizeUrl=(src,w)=>!src?src:`${src}${src.includes('?')?'&':'?'}width=${Math.round(w)}`;

  function setMainSrc(main){
    const dpr=Math.min(window.devicePixelRatio||1,2);
    const need=Math.min(main.clientWidth*dpr,MAIN_MAX);
    const base=(main.dataset.full||main.src).split('?')[0];
    const url=resizeUrl(base,Math.max(need,480));
    if(main.src!==url) main.src=url;
  }
  function setLensBG(main,lens){
    const dpr=Math.min(window.devicePixelRatio||1,2);
    const base=(main.dataset.full||main.src).split('?')[0];
    const want=Math.min(main.clientWidth*ZOOM*dpr*1.4,LENS_MAX);
    lens.style.backgroundImage=`url('${resizeUrl(base,Math.max(800,want))}')`;
    lens.style.backgroundSize=`${main.clientWidth*ZOOM}px ${main.clientHeight*ZOOM}px`;
  }

  function init(root){
    if(!root || root.dataset.dlbInit==='1') return; root.dataset.dlbInit='1';
    const main=q('.dlb-main',root), lens=q('.dlb-lens',root), cap=q('.dlb-cap',root), box=q('.dlb-imgbox',root);
    const thumbs=qa('.dlb-thumb',root);

    qa('.dlb-thumb img',root).forEach(img=>img.src=resizeUrl(img.src,THUMB_W));
    if(thumbs.length && !thumbs[0].classList.contains('is-active')){
      thumbs[0].classList.add('is-active');
      main.dataset.full=(thumbs[0].dataset.full||q('img',thumbs[0]).src).split('?')[0];
      setMainSrc(main); setLensBG(main,lens);
    }

    thumbs.forEach(btn=>{
      btn.addEventListener('click',e=>{
        e.preventDefault();
        thumbs.forEach(b=>b.classList.toggle('is-active',b===btn));
        main.dataset.full=(btn.dataset.full||q('img',btn).src).split('?')[0];
        cap.textContent=btn.dataset.cap||'';
        setMainSrc(main); setLensBG(main,lens);
      });
    });

    root.addEventListener('keydown',e=>{
      if(!['ArrowLeft','ArrowRight'].includes(e.key)) return;
      const i=thumbs.findIndex(b=>b.classList.contains('is-active')); if(i<0) return;
      const n=e.key==='ArrowRight'?(i+1)%thumbs.length:(i-1+thumbs.length)%thumbs.length;
      thumbs[n].click();
    });

    function moveLens(e){
      const r=box.getBoundingClientRect(), half=LENS/2;
      const x=e.clientX-r.left, y=e.clientY-r.top;
      const lx=Math.max(half,Math.min(r.width-half,x));
      const ly=Math.max(half,Math.min(r.height-half,y));
      lens.style.left=(lx-half)+'px'; lens.style.top=(ly-half)+'px';
      const rx=(lx/r.width)*(main.clientWidth*ZOOM-LENS);
      const ry=(ly/r.height)*(main.clientHeight*ZOOM-LENS);
      lens.style.backgroundPosition=`-${rx}px -${ry}px`;
    }
    box.addEventListener('mouseenter',()=>{ setLensBG(main,lens); lens.style.display='block'; });
    box.addEventListener('mousemove',moveLens);
    box.addEventListener('mouseleave',()=>{ lens.style.display='none'; });

    const update=()=>{ setMainSrc(main); setLensBG(main,lens); };
    window.addEventListener('resize',update);
    main.addEventListener('load',()=>setLensBG(main,lens));
  }

  function initAll(){ qa('[data-dlb="lookbook"]').forEach(init); }

  if(document.readyState==='complete'||document.readyState==='interactive') initAll();
  else document.addEventListener('DOMContentLoaded',initAll);
  window.addEventListener('load',initAll);
  document.addEventListener('shopify:section:load',e=>qa('[data-dlb="lookbook"]',e.target).forEach(init));

  // debug marker so you can see it loaded
  console.log('[DOSMIL] lookbook JS loaded');
})();
